import React, { useState } from "react";
import { HelpCircle } from "lucide-react";

/**
 * FieldTip — small `?` icon rendered next to a label. On hover / focus shows a
 * short helper card explaining why we ask, an example, and impact on match rate.
 *
 * Usage:
 *   <label>Amount Required <FieldTip
 *     why="Ticket size is the single filter 92% of investors set."
 *     example="e.g. ₹5 Cr for a Series A round"
 *     impact="Filling raises match hit-rate ~2.4×"
 *   /></label>
 */
export default function FieldTip({ why, example, impact }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-block ml-1 align-middle">
      <button
        type="button"
        onClick={() => setOpen((x) => !x)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        className="text-ink-muted hover:text-emerald-700 transition-colors align-middle inline-flex"
        aria-label="Field help"
        data-testid="field-tip-toggle"
      >
        <HelpCircle size={13} />
      </button>
      {open && (
        <span
          className="absolute z-50 left-4 top-4 w-64 bg-[#0F3D2E] text-white rounded-md p-3 shadow-lg text-xs leading-relaxed normal-case tracking-normal font-body"
          role="tooltip"
          data-testid="field-tip-popover"
        >
          {why && <div className="mb-1.5"><span className="text-emerald-300 font-mono uppercase text-[9px] tracking-widest mr-1">Why</span>{why}</div>}
          {example && <div className="mb-1.5 text-white/80"><span className="text-emerald-300 font-mono uppercase text-[9px] tracking-widest mr-1">Ex</span>{example}</div>}
          {impact && <div className="text-emerald-200"><span className="text-emerald-300 font-mono uppercase text-[9px] tracking-widest mr-1">Impact</span>{impact}</div>}
        </span>
      )}
    </span>
  );
}
